import React, { Component } from 'react';
import { BarLoader } from 'react-spinners';
import { colors } from 'themes/colors';

class LoadingScreen extends Component {
  render() {
    return (
      <div className="loading" style={styles.container}>
        <BarLoader
          color={colors.primary}
          height={8}
          width={150}
          loading={true}
        />
        <span style={styles.loadingText}>Hold On</span>
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '2rem',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  loadingText: {
    fontSize: '1.5rem',
    margin: '1rem',
    color: colors.primary,
    fontWeight: 'bold',
  },
};

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/LoadingScreen/LoadingScreen.js